import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '@nerdwallet/react-loading-spinner';

const WalletSpinner = (props) => (
  <div className="primary">
    <div className="wallet-spinner">
      <div className="container">
        <Spinner type="n" />
      </div>
      <div className="extra-text-logo">
        <img
          src="/global-styles/img/logos/nerdwallet-logo-new.png"
          alt="NerdWallet Logo"
        />
        <span className="extra-text">{props.extraText}</span>
      </div>
    </div>
  </div>
);

WalletSpinner.propTypes = {
  extraText: PropTypes.string,
};

WalletSpinner.defaultProps = {
  extraText: 'One moment, pulling up that offer for you...',
};

WalletSpinner.displayName = 'WalletSpinner';

export default WalletSpinner;
